// extracted by mini-css-extract-plugin
export default {"textButton":"textButton_textButton__fM0dH"};